import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { parseCurrency } from '../../../utils';

interface CurrencyInputProps extends Omit<TextFieldProps, 'onChange' | 'value'> {
  value: number | undefined;
  onChange: (value: number) => void;
  precision?: number;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({ value, onChange, precision = 2, ...props }) => {
  const formatValue = (val: number | undefined): string => {
    if (!val || val === 0) {
      return "R$ 0," + "0".repeat(precision);
    }
    return `R$ ${Number(val).toFixed(precision).replace('.', ',')}`;
  };

  const parseValue = (val: string): number => {
    if (!val || val === '') {
      return 0;
    }
    return parseCurrency(val, precision);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parsed = parseValue(e.target.value);
    onChange(parsed);
  };

  return (
    <TextField
      {...props}
      value={formatValue(value)}
      onChange={handleChange}
      inputProps={{
        ...props.inputProps,
        inputMode: 'decimal',
      }}
    />
  );
};

export default CurrencyInput;
